import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAdditionalDetailsFTL extends Layout {
    buttonShare: Button;
    labelOrderEmail: Label;
    sourceCustomerOrderDetail: DataSource;
    sourceOrderReferenceNumbers: DataSource;
    tableReferenceNumbers: Table;
}
